module.exports = __webpack_public_path__ + "img/goldregen-2020-124.067824ea.jpg";